/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmIncidentManagementToolsType from '@jira/spa-apps__admin-pages-products-jsm-incident-management-tools/src/ProductsJsmIncidentManagementToolsType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmIncidentManagementTools: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProductsJsmIncidentManagementToolsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-products-jsm-incident-management-tools", jiraSpaEntry: "async-products-jsm-incident-management-tools" */ '@jira/spa-apps__admin-pages-products-jsm-incident-management-tools/src/ProductsJsmIncidentManagementToolsType.tsx'
			),
		),
	);

const AsyncProductsJsmIncidentManagementTools = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmIncidentManagementTools}
		pageId="products-jsm-incident-management-tools"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmIncidentManagementTools;
